var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M6.6665 1.33325L5.99984 1.99992H2.6665V3.33325H13.3332V1.99992H9.99984L9.33317 1.33325H6.6665ZM3.33317 4.66659V13.3333C3.33317 14.0666 3.93317 14.6666 4.6665 14.6666H11.3332C12.0665 14.6666 12.6665 14.0666 12.6665 13.3333V4.66659H3.33317ZM5.33317 5.99992H6.6665V13.3333H5.33317V5.99992ZM9.33317 5.99992H10.6665V13.3333H9.33317V5.99992Z",
          fill: "CurrentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }